import type { TimeWindow } from '@ops/features/filter-cards';
import type { ReactNode } from 'react';
import type { DateRangeValue } from '@/shared/ui';
import { TIME_WINDOWS } from '@ops/features/filter-cards';
import { Sparkles } from 'lucide-react';
import {
  Button,
  DateRangePicker,
  OPERATIONS_PRESETS,
  Tab,
  TabBar,
  TableSearchInput,
} from '@/shared/ui';
import css from './dashboard-toolbar.module.scss';

type DashboardScope = 'all' | 'mine';

type DashboardToolbarProps = {
  /** The page-wide Today/Next-3-days/This-week/Custom window. */
  window: TimeWindow;
  onSelectWindow: (window: TimeWindow) => void;
  /** Custom range endpoints (ISO). Only meaningful when window === 'custom'. */
  customRange: DateRangeValue;
  onCustomRangeChange: (range: DateRangeValue) => void;
  search: string;
  onSearchChange: (value: string) => void;
  scope: DashboardScope;
  onScopeChange: (scope: DashboardScope) => void;
  onAsk: () => void;
  /** The self-contained Recent-changes trigger + dropdown. */
  recentSlot: ReactNode;
};

export const DashboardToolbar = ({
  window,
  onSelectWindow,
  customRange,
  onCustomRangeChange,
  search,
  onSearchChange,
  scope,
  onScopeChange,
  onAsk,
  recentSlot,
}: DashboardToolbarProps) => (
  <div className={css.root}>
    <TabBar>
      {TIME_WINDOWS.map((win) => (
        <Tab
          active={window === win.id}
          key={win.id}
          onClick={() => onSelectWindow(win.id)}
          size="sm"
          type="button"
        >
          {win.label}
        </Tab>
      ))}
    </TabBar>

    {window === 'custom' && (
      <DateRangePicker
        onChange={onCustomRangeChange}
        presets={OPERATIONS_PRESETS}
        size="sm"
        style={{ width: 180 }}
        value={customRange}
      />
    )}

    <div className={css.search}>
      <TableSearchInput
        onChange={onSearchChange}
        placeholder="Search itinerary, traveler, OptiGest ref…"
        value={search}
      />
    </div>

    <TabBar>
      <Tab
        active={scope === 'all'}
        onClick={() => onScopeChange('all')}
        size="sm"
        type="button"
      >
        All
      </Tab>
      <Tab
        active={scope === 'mine'}
        onClick={() => onScopeChange('mine')}
        size="sm"
        type="button"
      >
        Mine
      </Tab>
    </TabBar>

    <Button icon={<Sparkles size={15} />} onClick={onAsk} variant="secondary">
      Ask
    </Button>

    {recentSlot}
  </div>
);
